//import {version} from "../../../package.json";
const pkg = require('../../../package.json');
const version = pkg.version;

const CONST = {

    VERSION: version,

    APP_BASEURL: process.env.REACT_APP_BASEURL,
    ASSETS_BASE_URL: `${process.env.REACT_APP_BASEURL}/assets`,

    JS_NAMESPACE: 'CAABFCLIGHT',
    CSS_NAMESPACE: 'caabfcl-',

    DOM_APP_MOUNTPOINT_ID: 'caabfcl-app',
    DOM_APP_WIDGET_ID: 'caabfcl-widget',

    BROWSER_STORAGE_TYPE: 'localStorage',   // 'localStorage' or 'sessionStorage'
    BROWSER_STORAGE_KEY: 'caabfcl_' + version,

    FORCE_ASYNC_DELAY: 1000,

    VIEWMODE_EMBED: 'embed',
    VIEWMODE_STANDALONE: 'standalone',

    PREVIEW_WIDGET_SELECTOR: '[data-fincalc]',

    IDLE: 0,
    LOADING: 1,
    // SUCCESS: 2,
    // FAILURE: 3,

    WARNING: "warning",
    INFO: "info",
    ERROR: "error",

    SERVICETYPE_OPTIONAL: 'optional',
    SERVICETYPE_MANDATORY: 'mandatory',

    VEHICLE_TYPE: {
        USED: 'USED',
        NEW: 'NEW'
    },

    LEAD_FORM_URL: {
        DEFAULT: process.env.REACT_APP_LEAD_FORM_URL_NL,
        FR: process.env.REACT_APP_LEAD_FORM_URL_FR,
        NL: process.env.REACT_APP_LEAD_FORM_URL_NL
    }

};

export default CONST;
